export default __webpack_public_path__ + "static/5-16594c5eb1c0e1aef15d2e99575565d3.png";